module.exports = __webpack_public_path__ + "img/profile.9a40a7fe.jpg";